/**
 * Data layer — SEO-rich aggregator for products
 * This file expects the enriched JSON files to be located alongside this file at build time.
 * If you keep the old files, this remains backward-compatible.
 */

import type { CategoryDefinition } from "@src/types/product";

export const categories: CategoryDefinition[] = [
    {
        id: "flours",
        name: "Flours",
        description: "Freshly milled, nutrient-rich flours from our all-natural grains and crops.",
        metaDescription:
            "All-natural, nutrient-rich flours—plantain, corn, pap and groundnut. Wholegrain options for gluten-free cooking, baking and traditional swallows.",
        imageUrl:
            "images/products/flours/plantain/smooth-plantain-Flour-holiday-tree-with-lights.png",
        productCount: 1,
    },
    {
        id: "dried-vegetables",
        name: "Dried Vegetables",
        description:
            "Carefully dried Nigerian vegetables prepared for convenient everyday cooking, soups, swallows and traditional meals.",
        metaDescription:
            "Shop dried Nigerian vegetables like dried ewedu/jute leaves in resealable pouches. Made in Ogun State with fast delivery to Abeokuta, Ago-Iwoye, Ibadan, Lagos and nationwide Nigeria.",
        imageUrl: "images/products/dried-vegetables/ewedu/dried-ewedu-jute-leaves-pouch-lineup.png",
        productCount: 1,
    },
    {
        id: "dried-grains",
        name: "Dried Grains",
        description:
            "Naturally grown and processed wholegrain from our nature-powered farm, including corn and groundnuts rich in nutrients and flavor.",
        metaDescription:
            "Naturally grown and processed wholegrain like white corn and groundnuts—nutritious staples for pap, roasting, snacks and home cooking.",
        imageUrl:
            "images/products/dried-grains/groundnut/carefully-dried-groundnuts-on-a-metal-surface.png",
        productCount: 2,
    },
    // {
    //     id: "dried-herbs",
    //     name: "Dried Herbs",
    //     description:
    //         "Sustainably grown and carefully dried herbs that retain their full flavor and medicinal properties.",
    //     metaDescription:
    //         "Carefully dried natural herbs—mint, marigold, lemongrass, basil, lavender and more—for teas, cooking, skincare and aromatherapy.",
    //     imageUrl: "images/products/dried-herbs/menthol-mint/dried-menthol-mint-in-a-jar.jpg",
    //     productCount: 6,
    // },
    // {
    //     id: "essential-oils",
    //     name: "Essential Oils",
    //     description:
    //         "Pure, steam-distilled plant essential oils from our naturally grown herbs. Made for fragrance, diffusers, and DIY home blends. Always dilute before any skin use. Not for ingestion or medical use.",
    //     metaDescription:
    //         "Steam-distilled mint, peppermint, lavender, and rosemary essential oils—crafted from naturally grown plants for diffusers, home fragrance, and DIY blends. Always dilute; not for ingestion or medical use.",
    //     imageUrl: "images/products/essential-oils/lavender-essential-oil-in-4-bottles.jpg",
    //     productCount: 4,
    // },
    // {
    //     id: "infused-oils",
    //     name: "Infused Oils",
    //     description:
    //         "Carefully infused oils that capture the beneficial properties of our naturally grown and processed herbs.",
    //     metaDescription:
    //         "Carrier oils gently infused with all-natural herbs - marigold, mint, spearmint, lemongrass, basil—for massage, skincare and aromatherapy.",
    //     imageUrl:
    //         "images/products/infused-oils/peppermint/gu-peppermint-infused-oil-for-aromatherapy.png",
    //     productCount: 4,
    // },
    // {
    //     id: "floral-waters",
    //     name: "Floral Waters",
    //     description:
    //         "Pure, gentle floral waters created during the steam distillation of our all-natural herbs, offering natural botanical benefits.",
    //     metaDescription:
    //         "Pure hydrosols from steam distillation—mint, marigold, lavender, rosemary and more—gentle natural toners and refreshing mists.",
    //     imageUrl: "images/products/floral-waters/lemongrass-hydrosol-on-marble-table.jpg",
    //     productCount: 9,
    // },
    // {
    //     id: "seedlings",
    //     name: "Plant Seedlings",
    //     description:
    //         "Healthy, naturally raised seedlings ready to transplant into your garden. Start your own herb and vegetable patch with our carefully nurtured young plants.",
    //     metaDescription:
    //         "Healthy naturally raised seedlings - mint, peppermint, spearmint, menthol mint, lavender, basil, marigold and Indian borage—ready to transplant.",
    //     imageUrl:
    //         "images/products/seedlings/marigold/marigold-seedlings-in-a-red-disposable-cup.png",
    //     productCount: 8,
    // },
    {
        id: "seeds",
        name: "Plant Seeds",
        description:
            "Healthy, naturally produced seeds ready to plant in your garden. Start your own herb and vegetable patch with our carefully selected, high-quality varieties.",
        metaDescription:
            "High-germination natural seeds for your garden, including marigold and groundnut—grow vibrant, beneficial, pollinator-friendly plants at home.",
        imageUrl: "images/products/seeds/marigold-seeds-in-bowl-and-pouch.png",
        productCount: 8,
    },
];

export default categories;
